import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import Announcement from './Announcement'
import Hero from './Hero'
import Block from './Block'
import Billboard from './Billboard'

const Banner = {
  Announcement: withErrorBoundary(Announcement),
  Hero: withErrorBoundary(Hero),
  Block: withErrorBoundary(Block),
  Billboard: withErrorBoundary(Billboard),
} as const

export default Banner
